import { SettingValues } from '@linearb/linjs-common';
import useSettingsService from 'components/hooks/useSettingsService';

const useMetricsCalculationConfig = () => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const metricsCalculationStrategy =
    getSettingOrDefinitionValue({
      name: SettingValues.METRICS_CALCULATION_STRATEGY
    }) || 'avg';

  return {
    metricsCalculationStrategy
  };
};

export default useMetricsCalculationConfig;
